"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const bulkWizardActionsContext_1 = __importDefault(require("../contexts/bulkWizardActionsContext"));
const useBulkWizardActionsContext = () => {
    const context = (0, react_1.useContext)(bulkWizardActionsContext_1.default);
    if (!context) {
        throw new Error('useBulkWizardActionsContext must be used within a specific provider');
    }
    return context;
};
exports.default = useBulkWizardActionsContext;
